import { PART_TYPES } from '../enums'

const data = [
  { subType: PART_TYPES.JEWELRY_EARRINGS, title: 'avatar.earrings' },
  { subType: PART_TYPES.JEWELRY_NECKLACES, title: 'avatar.necklaces' },
]

export default data
